export default function PHP_flush() {
  return (
    <div>
      <h1>PHP_flush</h1>
    </div>
  );
}
